import * as React from 'react';

import type {WidgetFragment} from 'nutshell-graphql-types';

import {EmailSequencesWidget} from '../../../core-entity/widgets/email-sequences-widget/email-sequences-widget';
import type {PostMutationCallbacks} from '../../../core-entity/widgets/email-sequences-widget/types';

import {refetchForEvent} from '../../refetch-helpers';

import {useGetLeadDripSequences} from './graphql/hooks/use-get-lead-drip-sequences';
import {useGetLeadManuallyStartedEmailSequences} from './graphql/hooks/use-get-lead-manually-started-email-sequences';
import {useGetLeadPersonalEmailSequences} from './graphql/hooks/use-get-lead-personal-email-sequences';
import {extractEmailAutomationStatuses, getLeadDripContacts} from './helpers';

type Props = {
    leadId: string;
    widget: WidgetFragment;
};

const postMutationCallbacks: PostMutationCallbacks = {
    cancelDrip: () => refetchForEvent('dripSequenceCancel'),
    cancelManual: () => refetchForEvent('manuallyStartedPersonalEmailSequenceCancel'),
    startPersonal: () => refetchForEvent('personalEmailSequenceStart'),
    sendNow: () => refetchForEvent('personalEmailSequenceSendNow'),
};

export function LeadEmailSequencesWidget(props: Props) {
    const {dripSequences, isFirstLoading: isFirstLoadingDripSequences} = useGetLeadDripSequences(
        props.leadId
    );
    const {stages, isFirstLoading: isFirstLoadingPersonalEmailSequences} =
        useGetLeadPersonalEmailSequences(props.leadId);
    const {queuedEmails, isFirstLoading: isFirstLoadingManuallyStartedEmailSequences} =
        useGetLeadManuallyStartedEmailSequences(props.leadId);

    const emailAutomationStatuses = React.useMemo(
        () => extractEmailAutomationStatuses(stages),
        [stages]
    );

    const contactsWithDripProgressions = React.useMemo(
        () => getLeadDripContacts(dripSequences),
        [dripSequences]
    );

    return (
        <EmailSequencesWidget
            widget={props.widget}
            contactsWithDripProgressions={contactsWithDripProgressions}
            emailAutomationStatuses={emailAutomationStatuses}
            queuedEmails={queuedEmails}
            isFirstLoadingDripSequences={isFirstLoadingDripSequences}
            isFirstLoadingEmailAutomationStatuses={isFirstLoadingPersonalEmailSequences}
            isFirstLoadingManuallyStartedSequences={isFirstLoadingManuallyStartedEmailSequences}
            postMutationCallbacks={postMutationCallbacks}
        />
    );
}
